<template>
    <div class="p-5 mt-5 dashboard-content">
      <div class="content">
        <div id="about-me" class="interactive-section" style="display: block">
          <h2 style="color: #007bff" class="text-2xl">
            <b>TESTEK - KIỂM THỬ THỰC CHIẾN</b>
          </h2>
          <div class="grid-container">
            <div class="grid-item">
              <h4 class="text-lg">
                Đào tạo API Testing, Performance Testing, Automation Testing
              </h4>
              <h4 class="text-lg">
                Website:
                <a href="https://testek.vn" target="_blank">https://testek.vn</a>
              </h4>
              <h4 class="text-lg">
                Discord:
                <a href="https://discord.gg/jC7ZtmvuDX" target="_blank"
                  >Testek - Kiểm thử thực chiến</a
                >
              </h4>
              <h4 class="text-lg">
                Facebook:
                <a
                  href="https://www.facebook.com/share/g/15m67fr73k/"
                  target="_blank"
                  >Testek - Kiểm thử thực chiến</a
                >
              </h4>
              <h4 class="text-lg">
                Hotline: 083.286.8822 / Email: vntestek@gmail.com
              </h4>
              <h4 class="text-lg">Các hệ thống Testek cung cấp</h4>
              <ul class="custom-resource">
                <li class="text-lg">
                  API System:
                  <a
                    href="https://lab-ecom-api.labit.vn/v0/prod-man/swagger-ui.html#/"
                    target="_blank"
                    >Swagger</a
                  >
                </li>
                <li class="text-lg">
                  Automation Web:
                  <a href="https://lab-ecom.labit.vn/login" target="_blank"
                    >Product Management</a
                  >
                </li>
                <li class="text-lg">
                  Web Element:<a
                    href="https://lab-ecom.labit.vn/web-elements"
                    target="_blank"
                  >
                    Basic Web Elements</a
                  >
                </li>

                <li class="text-lg">
                  Account (<b><i>for API System & Automation Web</i></b>):
                  <ul class="custom-resource">
                    <li>Admin: admin_com_role </li>
                    <li>User: user_com_role </li>
                    <li>Guest: guest_com_role </li>
                    <li>Password: aA12345678@ </li>
                  </ul>
                </li>

                <li class="text-lg">
                  Database: Updating...
                  <!-- <ul class="custom-resource">
                    <li class="text-lg">UR:</li>
                    <li class="text-lg">DB Name:</li>
                    <li class="text-lg">Account:</li>
                  </ul> -->
                </li>
              </ul>
            </div>
            <div
              class="grid-item"
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
              "
            >
              <div class="mt-8 mb-6 text-lg">Buy Me a Coffee</div>
              <img
                src="https://lh3.googleusercontent.com/d/1jomM5CqmS7JPuI9docJdnBeYil5vR_yR=s220"
                style="width: 216px; height: 300px"
              />
              <div class="mt-5" style="font-size: 12px">
                Nếu bạn thấy có ích hãy cùng mình duy trì page này nhé (5k, 10k là
                quý lắm ạ)
              </div>
            </div>
          </div>
  
          <h4 class="text-lg">
            <b
              >HỆ THỐNG THỰC HÀNH CƠ BẢN TRONG AUTOMATION TESTING, CÙNG CHUNG TAY XÂY DỰNG CỘNG ĐỒNG KIỂM THỬ TỰ ĐỘNG VIỆT NAM LỚN MẠNH!!!</b
            >
          </h4>
          <h4>
            ------------------------------------------------------------------------------------------------------------------------
          </h4>
          <!-- Embed TikTok video -->
          <div class="mt-6 mb-6">
            <blockquote
              class="tiktok-embed"
              cite="https://www.tiktok.com/@vntestek"
              data-unique-id="vntestek"
              data-embed-type="creator"
              style="max-width: 780px; min-width: 288px"
              id="v54865760131294320"
            >
              <iframe
                name="__tt_embed__v54865760131294320"
                sandbox="allow-popups allow-popups-to-escape-sandbox allow-scripts allow-top-navigation allow-same-origin"
                src="https://www.tiktok.com/embed/@vntestek?lang=en-US&amp;referrer=https%3A%2F%2Ftestek.vn%2Flab%2Fauto%2Fweb-elements%2F"
                style="
                  width: 100%;
                  height: 210px;
                  display: block;
                  visibility: unset;
                  max-height: 210px;
                "
              ></iframe>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "Dashboard",
    data() {
      return {};
    },
    created() {
      const me = this;
      me.$emitter.emit("MenuActive", { router: "/dashboard" });
    },
    mounted() {
      this.loadTikTokEmbed();
    },
    methods: {
      loadTikTokEmbed() {
        if (
          !document.querySelector('script[src="https://www.tiktok.com/embed.js"]')
        ) {
          const script = document.createElement("script");
          script.src = "https://www.tiktok.com/embed.js";
          script.async = true;
          document.body.appendChild(script);
        } else {
          window.tiktokEmbedLoad && window.tiktokEmbedLoad(); // Cập nhật lại nếu script đã load
        }
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .dashboard-content {
    height: 100%;
    overflow: auto;
  }
  .content {
    margin-right: 20%;
  }
  .li {
  }
  .title-color {
    color: #007bff;
  }
  .grid-container {
    display: grid;
    grid-template-columns: 10fr 4fr;
    gap: 10px;
  }
  
  .grid-item {
    border: 0px solid #ccc;
    padding: 10px;
  }
  
  ul.custom-resource {
    list-style-type: disc;
    padding-left: 20px;
  }
  
  ul.custom-resource li {
    margin-bottom: 10px;
  }
  
  ul.custom-resource a {
    color: #007bff;
    text-decoration: none;
  }
  
  ul.custom-resource a:hover {
    text-decoration: underline;
  }
  
  h4 {
    display: block;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
  }
  blockquote {
    margin-block-start: 0rem;
    margin-block-end: 0em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  a {
    text-decoration: none;
    color: #007bff;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
</style>